<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="800">
    <v-form ref="form" class="px-11 py-10 white">
      <v-row class="pb-10">
        <v-col cols="11">
          <p class="form__title mb-0 gray--text">
            {{ title }}
          </p>
        </v-col>
        <v-col cols="1" class="text-end pb-5">
          <BaseButton text icon @click="closeModal" class="justify-end">
            <v-icon size="17" color="gray" class="justify-end">
              fa-times
            </v-icon>
          </BaseButton>
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5">
          <BaseFormInput
            id-element="nameCreditLineContact"
            placeholder="Digite"
            v-model="item.nome"
            required
            validate-on-blur
            :rules="[requiredInput]"
            label-text="Nome"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <BaseFormInput
            id-element="emailCreditLineContact"
            placeholder="Digite"
            v-model="item.email"
            required
            validate-on-blur
            :rules="[requiredInput, isValidEmail]"
            label-text="E-mail"
            :upper-case="false"
          />
        </v-col>
        <v-col cols="12">
          <BaseFormInput
            id-element="departamentCreditLineContact"
            placeholder="Digite"
            v-model="item.departamento"
            required
            validate-on-blur
            :rules="[requiredInput]"
            label-text="Departamento"
          />
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5">
          <BaseFormInput
            id-element="firstPhoneCreditLineContact"
            placeholder="Digite"
            v-model="item.telefone1"
            required
            validate-on-blur
            :rules="[requiredInput, isValidPhoneNumber]"
            v-facade="maskPhone"
            label-text="Comercial"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <BaseFormInput
            id-element="secondPhoneCreditLineContact"
            placeholder="Digite"
            v-model="item.telefone2"
            validate-on-blur
            v-facade="maskPhone"
            :rules="[isValidPhoneNumber]"
            label-text="Celular"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="4" md="3">
          <BaseButton
            v-html="'ADICIONAR'"
            width="100%"
            class="secondary white--text"
            @click="submit"
          >
          </BaseButton>
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import {
  requiredInput,
  isValidPhoneNumber,
  isValidEmail
} from "@/utils/rules.js";
import { maskPhone } from "@/utils/masks.js";

export default {
  name: "NewContactModal",
  data: () => ({
    requiredInput,
    isValidPhoneNumber,
    maskPhone,
    isValidEmail
  }),
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit", this.item);
    }
  },
  props: {
    title: {
      type: String
    },
    item: {
      type: Object
    }
  }
};
</script>
